<template lang="pug">
    fragment
        // Arrow
        td
            v-icon.icon(:class="{'expanded' : expanded}") keyboard_backspace

        // ID
        td {{ item.id }}

        // Times redeemed
        td {{ item.times_redeemed }}

        // Actions
        td.px-0.text-xs-right

            // Delete manager button
            button-component(:action="remove" color="primary" icon="delete")
</template>

<script>
    import VueTypes from 'vue-types';
    import ButtonIcon from '~components/ButtonIcon';
    import Status from '~components/Status';
    import { mapActions } from 'vuex';

    export default {
        components: {
            ButtonComponent: ButtonIcon,
            StatusComponent: Status
        },
        props: {
            item: VueTypes.object.def({}),
            expanded: VueTypes.bool.def(false)
        },
        methods: {
            ...mapActions('coupons', ['delete', 'getCoupons']),

            /**
             * Delete coupon.
             * @returns {Promise<void>}
             */
            async remove() {
                const resp = await this.delete(this.item.id);

                if (resp) {
                    this.getCoupons();
                }
            }
        }
    };
</script>

<style lang="stylus" scoped>
    @import "../../../../assets/style/_variables.styl"

    .role
        width: 30px
        height: 30px
        border-radius: 30px
        background-color: rgba(255, 255, 255, 0.2)
        text-align: center
        font-size: 22px

    .fullName
        max-width: 140px
        overflow: hidden
        text-overflow: ellipsis
</style>
